import { IRapportDefs, IRapportInfos } from '../../../../Types/RapportInfoType';
import { rutinInfos } from './RutinInfo';

// Lista av alla rapporter med info om vilka rutiner de hör till

const rapportDefs: IRapportDefs = {
  BOForsamlingsstatistik: {
    rutinID: rutinInfos.rtnStatistikrapporteringNew.rutinID,
    benamning: 'Församlingsstatistik',
    beskrivning:
      'Rapporten Församlingsstatistik summerar antal tillfällen och antal besökare uppdelat per typ av aktivitet.',
    typ: 'Excelrapport',
  },
  BJEtikett: {
    rutinID: rutinInfos.rtnWebBisattningsAktAvlidna.rutinID,
    benamning: 'QR-etikett',
    beskrivning:
      'Rapporten skapar vald QR-etikett för kista, urna, minneslund.',
    typ: 'PDF-rapport',
  },
  BOPDFKalenderReport: {
    rutinID: rutinInfos.rtnAktiviteter.rutinID,
    benamning: 'Skapa rapport',
    beskrivning: '',
    typ: 'PDF-rapport',
  },
};

// Omvandlar IRapportDefs till IRapportInfos

export const rapportInfos: IRapportInfos = Object.keys(rapportDefs).reduce<IRapportInfos>(
  (infos, rapportID) => {
    infos[rapportID] = {
      rapportID: rapportID,
      rutinID: rapportDefs[rapportID].rutinID,
      benamning: rapportDefs[rapportID].benamning,
      beskrivning: rapportDefs[rapportID].beskrivning,
      typ: rapportDefs[rapportID].typ,
    };
    return infos;
  },
  {}
);
